import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getBackOfficePersonServices = (paginate, person_id) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/back_office_person_service/${person_id}`
    );
  }
  return http.get(
    `${getBaseUrl()}/back_office_person_service/${person_id}?${paginate}`
  );
};


export const getBackOfficeAgentServices = (paginate, person_id) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/back_office_agent_service/${person_id}`
    );
  }
  return http.get(
    `${getBaseUrl()}/back_office_agent_service/${person_id}?${paginate}`
  );
};

export const submitBackOfficeService = data => {

  return http.post(
    `${getBaseUrl()}/back_office_person_service/${data.person_id}`,
    data
  );
};

export const updateBackOfficeServicePayment = data => {

  return http.put(
    `${getBaseUrl()}/back_office_service_payment/${data.person_id}`,
    data
  );
};

export const updateBackOfficeServiceFirstPayment = data => {

  return http.put(
    `${getBaseUrl()}/back_office_service_first_payment/${data.person_id}`,
    data
  );
};

export const updateBackOfficeServiceSecondPayment = data => {

  return http.put(
    `${getBaseUrl()}/back_office_service_second_payment/${data.person_id}`,
    data
  );
};